import React from 'react';

import engagementPanels from '../../../data/config/engagement-panels.json';
import { EngagementPanelBlock } from '.';

const ReusableEngagementPanel: React.FC<{
  id: string;
}> = ({ id }) => {
  const panel = engagementPanels.engagement_panels?.find(
    panel => panel.engagement_panel_id === id
  );

  if (!panel) {
    return null;
  }

  return <EngagementPanelBlock block={panel} />;
};

export default ReusableEngagementPanel;
